<template>
  <v-toolbar height="48px" style="width: 100%; position: fixed; z-index: 10">
    <v-app-bar-nav-icon class="d-inline d-lg-none" @click="mini = !mini"></v-app-bar-nav-icon>
    <v-toolbar-title class="d-none d-md-inline mr-4">
      <span class="back" style="color: #3A3852; font-size: inherit; font-weight: 800">Payment</span><span class="office" style="font-size: inherit; font-weight: 800">Office</span>
    </v-toolbar-title>
    <div class="d-inline-block">
      <template v-for="group in cardGroups">
        <v-menu bottom offset-y v-if="entity[group.getter].length > 1">
          <template v-slot:activator="{ on, attrs }">
            <v-badge v-if="entity[group.getter].length > 1"
                :content="entity[group.getter].length"
                :value="entity[group.getter].length"
                left
                color="secondary"
                overlap
            >
              <v-btn outlined color="primary lighten-1" v-bind="attrs" v-on="on" class="mr-2">
                  <v-icon class="mr-2">{{group.icon}}</v-icon>
                  <v-icon small>mdi-menu-down</v-icon>
              </v-btn>
            </v-badge>
          </template>
          <v-list v-if="entity[group.getter].length > 1">
            <v-list-item v-for="card in entity[group.getter]" :key="`toolbar-${card.key}`">
              <v-list-item-title>
                <a @click="maximizeCard(card.key)">{{ card.title }}</a>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn v-else-if="entity[group.getter].length === 1"
               outlined
               color="primary lighten-1"
               class="mr-2"
               @click="maximizeCard(entity[group.getter][0].key)">
          <v-icon class="mr-2">{{group.icon}}</v-icon>
          <v-subheader class="ma-0 pa-0">{{entity[group.getter][0].title}}</v-subheader>
        </v-btn>
      </template>
    </div>
    <v-spacer></v-spacer>
    <v-btn icon>
      <!-- <v-icon small>mdi-bell</v-icon> -->
      <i class="icon-notification far fa-bell"></i>
    </v-btn>

    <v-menu
        :close-on-content-click="false"
        :nudge-width="200"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            text
            large
            v-bind="attrs"
            v-on="on"
            class="text-capitalize px-0"
        >
          <img class="user-avatar" :src="getUrlAvatar()" />
          <span class="d-none d-md-inline username">{{getUserName()}}</span>
          <v-icon small>mdi-menu-down</v-icon>
          <!-- <i class="fal fa-angle-down"></i> -->
        </v-btn>
      </template>

      <v-card class="text-right">
        <div class="pa-4 pb-0">
          You are currently signed in as<br>
          <strong>{{getUserEmail()}}</strong><br>({{ getUserRole() }})
        </div>
        <v-divider></v-divider>
        <v-list>
          <v-list-item @click="loginOut">
            <v-list-item-title>Sign out <v-icon>mdi-logout</v-icon></v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>

    <div class="d-none d-md-block role">{{ getUserRole() }}</div>
    <v-menu
        :close-on-content-click="false"
        :nudge-width="200"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon
               v-bind="attrs"
               v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-subheader>Themes</v-subheader>
        <v-list-item-group
            v-model="selectedWorkspace"
            color="primary"
            @change="changeWorkspace"
        >
          <v-list-item v-for="(item) in workspaces"
                       :key="`theme-${item.value}`" :value="item.value">
            <v-list-item-title><v-chip small class="mr-2" :color="item.color"></v-chip>{{item.text}}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>

<script>
import store from "@/store";
import {deleteCookie} from "@/helpers";
import {mapGetters, mapState} from "vuex";
import theme from "@/plugins/vuetify/theme";

export default {
name: "Header",
  data() {
    return {
      entity: this,
      workspaces: [
        {value: 'blue', text: 'Blue', color: theme['blue'].primary},
        {value: 'orange', text: 'Orange', color: theme['orange'].primary},
        {value: 'teal', text: 'Teal', color: theme['teal'].primary}
      ],
      selectedWorkspace: localStorage.getItem('workspace') || 'blue',
      showDropdown: false,
      drawer: false,
      mini: true,
      cardGroups: [
          {type: 'affiliate', icon: 'fal fa-user-friends', getter: 'affiliateCards'},
          {type: 'payment', icon: 'fal fa-money-check', getter: 'paymentCards'},
      ]
    }
  },
  watch: {
    mini() {
      this.$emit('input', this.mini)
    }
  },
  methods: {
    maximizeCard(key) {
      store.dispatch('cards/MAXIMIZE', key);
    },
    changeWorkspace(event) {
      console.log(this.selectedWorkspace);
      localStorage.setItem('workspace', this.selectedWorkspace)
      this.$vuetify.theme.themes.light = theme[this.selectedWorkspace];
    },
    getUrlAvatar() {
      return this.user.length > 0 && this.user[0].picture
    },
    getUserEmail() {
      return this.user.length > 0 && this.user[0].email
    },
    getUserName() {
      return this.user.length > 0 && this.user[0].name
    },
    getUserRole() {
      return this.user.length > 0 && this.user[0].role
    },
    markAllAsRead(event) {
      event.preventDefault()

      store.dispatch('managers/updateAccountNotificationsStore', { token: getCookie('accessToken'), notifications: this.getAccountNotifications })
    },
    loginOut() {
      deleteCookie('accessToken')
      this.$router.push('/login')
      location.reload()
    },
  },
  computed : {
    ...mapState('user', ['user']),
    ...mapGetters('cards', [
      'affiliateCards',
      'paymentCards',
    ])
  },
  created() {
    if (this.user[0]) {
      console.log('user');
      console.log(this.user[0]);
      if (!['blue', 'orange', 'teal'].includes(localStorage.getItem('workspace'))) {
        this.selectedWorkspace = 'blue';
        localStorage.setItem('workspace', this.selectedWorkspace);
        this.$vuetify.theme.themes.light = theme[this.selectedWorkspace];
        this.showDropdown = false;
      }
    }
  }
}
</script>

<style scoped>

</style>
